import Vue from 'vue'
import VueRouter from 'vue-router'
import Solo from '../views/talentfoerderung/Solo.vue'
import Ensemble from '../views/talentfoerderung/Ensemble.vue'
import Talente from '../views/talentfoerderung/Talente.vue'
import Fortbildung from '../views/fortbildung/Index.vue'
import Orchester from '../views/orchester/Index.vue'
import Mangelinstrumente from '../views/mangelinstrumente/Mangelinstrumente.vue'
import Pruefungsordnung from '../views/registrierung/Pruefungsordnung.vue'
import TagDerMusikschulen from '../views/registrierung/TagDerMusikschulen.vue'
import Initiativbewerbung from '../views/registrierung/Initiativbewerbung.vue'
import Gesamtabrechnung from '../views/abrechnung/Gesamtabrechnung.vue'
import TagDerAdmin from '../views/registrierung/TagDerAdmin.vue'
import Anmeldung from '../views/registrierung/Anmeldung.vue'
import WettbewerbEnsemble from '../views/wettbewerb/Ensemble.vue'
import WettbewerbTanzEnsemble from '../views/wettbewerb/TanzEnsemble.vue'
import WettbewerbSolo from '../views/wettbewerb/Solo.vue'
import FoerderungKukudu from '../views/kukudu/Foerderung.vue'
import BehindertenFoerderung from '../views/antraege/BehindertenFoerderung.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/talent/solo',
    name: 'Talentförderung Solo',
    component: Solo,
    props: (route) => ({ hash: route.query.hash })  
  },
  {
    path: '/talent/ensemble',
    name: 'Talentförderung Ensemble',
    component: Ensemble,
    props: (route) => ({ hash: route.query.hash })  
  },
  {
    path: '/talent',
    name: 'Talenteprogramm ohne Strukturförderung',
    component: Talente,
    props: (route) => ({ hash: route.query.hash })  
  },
  {
    path: '/fortbildung/:fortbildungtype',
    name: 'Fortbildung Onlineanmeldung',
    component: Fortbildung,
    props: true  
  },
  {
    path: '/orchester/:orchestertype',
    name: 'Orchester Onlineanmeldung',
    component: Orchester,
    props: true  
  },
  {
    path: '/mangelinstrumente',
    name: 'Mangelinstrumentenfoerderung',
    component: Mangelinstrumente,
    props: (route) => ({ hash: route.query.hash })  
  },
  {
    path: '/behindertenfoerderung',
    name: 'BehindertenFoerderung',
    component: BehindertenFoerderung
  },
  {
    path: '/pruefungsordnung',
    name: 'Prüfungsordnung',
    component: Pruefungsordnung,
    props: true,
  },
  {
    path: '/tdm',
    name: 'Tag der Musikschulen',
    component: TagDerMusikschulen,
  },
  {
    path: '/tda',
    name: 'Tag der Admin',
    component: TagDerAdmin,
    props: (route) => ({datum: route.query.datum})
  },
  {
    path: '/initiativbewerbung',
    name: 'Initiativbewerbung',
    component: Initiativbewerbung,
    props: true,
  },
  {
    path: '/gesamtabrechnung',
    name: 'Gesamtabrechnung',
    component: Gesamtabrechnung,
    props: (route) => ({ hash: route.query.hash }) 
  },
  {
    path: '/anmeldung/:id',
    name: 'Anmeldung',
    component: Anmeldung,
    props: true
  },
  {
    path: '/wettbewerb/ensemble/:id',
    name: 'Wettbewerb (Ensemble)',
    component: WettbewerbEnsemble,
    props: true
  },
  {
    path: '/wettbewerb/solo/:id',
    name: 'Wettbewerb (Solo)',
    component: WettbewerbSolo,
    props: true
  },
  {
    path: '/wettbewerb/tanz/:id',
    name: 'Wettbewerb (Tanzensemble)',
    component: WettbewerbTanzEnsemble,
    props: true
  },
  {
    path: '/kukudu/foerderung',
    name: 'KUKUDU Strukturförderung',
    component: FoerderungKukudu,
    props: false
  },
]

const router = new VueRouter({
  base: '/forms/',
  routes
})

export default router
